import { Container } from '../ui/Container'
import { Eyebrow } from '../ui/Eyebrow'
import { Reveal } from '../ui/Reveal'

const symptoms = [
  'Websites become outdated',
  'Processes become manual',
  'Information becomes fragmented',
  'Customers expect better digital experiences',
  'Teams rely on disconnected tools',
  'Technology becomes a bottleneck instead of an advantage',
]

export function Problem() {
  return (
    <section className="border-b border-ink/10 py-24 md:py-32">
      <Container>
        <div className="grid gap-12 md:grid-cols-2 md:gap-20">
          <Reveal>
            <Eyebrow>The problem</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-semibold leading-tight tracking-tight text-balance md:text-5xl">
              Businesses outgrow their tools.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-graphite">
              What worked when a business was small does not always work as it grows.
            </p>
          </Reveal>

          <Reveal delay={150}>
            <ul className="flex flex-col divide-y divide-ink/10 border-t border-ink/10">
              {symptoms.map((symptom) => (
                <li key={symptom} className="py-4 text-base text-ink/80">
                  {symptom}
                </li>
              ))}
            </ul>

            <p className="mt-10 text-lg font-medium leading-relaxed">
              That&apos;s where we come in. We help organizations design, build, and improve digital
              products and systems around the way they actually work.
            </p>
          </Reveal>
        </div>
      </Container>
    </section>
  )
}
